/**
 * Handle the form submit
 *
 * @param data
 * @param {string} url - the URL
 * @param {object} callbacks - object containing the callback methods
 */
export const onSubmit = async (url, data, callbacks) => {
  const { onError, onSuccess } = callbacks;

  const fieldsArray = Object.keys(data).map((item) => {
    return {
      name: item,
      value: data[item],
    };
  });

  const hubspotData = {
    submittedAt: Date.now(),
    fields: fieldsArray,
  };

  try {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(hubspotData),
    })
      .then((res) => {
        return res.json();
      })
      .then((resJson) => {
        // Hubspot's API returns a status only when there is an error
        if (resJson.status === undefined) {
          // Show success message, no design for it yet
          onSuccess();
        } else if (resJson.status === 'error') {
          onError();
        }
      })
      .catch((err) => console.error(err));
  } catch (error) {
    throw new Error(error);
  }
};
